import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="layout">
      <header className={`header ${isHomePage ? 'header-transparent' : ''}`}>
        <div className="container">
          <nav className="nav">
            <Link to="/" className="logo">
              <span className="logo-text">GOLMACHI</span>
            </Link>
          </nav>
        </div>
      </header>
      
      <main className="main-content">
        {children}
      </main>
      
      {isHomePage && (
        <section className="notice-area">
          <div className="container">
            <div className="notice-card">
              <h4 className="notice-title">お知らせ</h4>
              <ul className="notice-list">
                <li>
                  <Link to="/news/company-change" className="notice-link">
                    <span className="notice-badge">重要</span>
                    【重要】ゴルマチ運営会社変更（事業譲渡）のお知らせ
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </section>
      )}

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>GOLMACHI</h4>
              <p>ゴルフで繋がる、新しい出会い</p>
            </div>
            <div className="footer-section">
              <h5>サービス</h5>
              <ul className="footer-links">
                <li><Link to="/">ホーム</Link></li>
                <li><Link to="/company">運営会社</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h5>法的情報</h5>
              <ul className="footer-links">
                <li><Link to="/privacy">プライバシーポリシー</Link></li>
                <li><Link to="/terms">利用規約</Link></li>
                <li><Link to="/tokutei">特定商取引法に基づく表記</Link></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 GOLMACHI. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
